export default __webpack_public_path__ + "static/media/magnifier-white.333c91b5.svg";